module.exports = __webpack_public_path__ + "static/media/3-5-ukrizovan.b3b1b53c.jpg";